import { groupBy } from 'lodash';

import { MultiSelectItem } from './MultiSelect.types';

export const sortAndSelectItems = <T extends MultiSelectItem>(items: T[], selectedItems: T[]): T[] =>
  items
    .map((item) => {
      if (selectedItems.find((s) => s.code === item.code)) {
        return { ...item, selected: true };
      }

      return { ...item, selected: false };
    })
    .sort((a, b) => (a.name > b.name ? 1 : -1));

export const groupItemsAlphabetically = <T extends { name: string }>(items: T[]): [string, T[]][] => {
  const alphabeticalGroup = groupBy(items, (i) => i.name.substring(0, 1).toLowerCase());

  return Object.entries(alphabeticalGroup);
};
